<template>
  <li class="column is-one-quarter" @click="$emit('setActiveChartContentName')">
    <div class="chart-selector" :class="{ isActiveChartContent }">
      <VsLoader :visible="!!chartData.isLoading" />
      <div class="upper-content">
        <h3 class="title">
          <span v-if="!isWithOutVirtusize" class="logo" :class="isActiveChartContent ? 'white' : 'green'">
            <Logo />
          </span>
          {{ chartContent.title | t }}
        </h3>
        <p class="text">
          {{ chartContent.content | t }}
        </p>
      </div>
      <div class="data">
        <p>{{ chartData.rateTotal | numberFormat("0.0%") }}</p>
        <hr />
        <p>{{ chartData.valueTotal | numberFormat("0,0") }}</p>
      </div>
    </div>
  </li>
</template>

<script>
import Logo from "@/assets/logos/logo.svg";

export default {
  components: {
    Logo,
  },
  props: {
    chartContent: {
      type: Object,
      required: true,
    },
    chartData: {
      type: Object,
      default: () => {},
    },
    activeChartContentName: {
      type: String,
      required: true,
    },
  },
  computed: {
    isActiveChartContent() {
      return this.chartContent.name === this.activeChartContentName && !this.chartData.isLoading;
    },
    isWithOutVirtusize() {
      return this.chartContent.name === "withoutVirtusize";
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-selector {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 232px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: $border-radius;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  cursor: pointer;

  .title {
    min-height: 32px;
    margin-bottom: 8px;
    font-size: 13px;

    .logo {
      vertical-align: middle;
    }

    .logo.white {
      svg {
        path {
          fill: $white;
        }
      }
    }

    .logo.green {
      svg {
        path {
          fill: $link-green;
        }
      }
    }
  }

  .text {
    font-weight: bold;
    font-size: 12px;
  }

  hr {
    height: 1px;
    margin: 10px 0;
    background: rgba(0, 0, 0, 0.2);
  }

  .data {
    font-size: 24px;
    text-align: right;
  }
}

.isActiveChartContent {
  color: $white;
  background-color: $primary;

  .title {
    color: $white;
  }

  &::after {
    position: absolute;
    bottom: -5px;
    left: calc(50% - 5px);
    width: 8px;
    height: 8px;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    background-color: $primary;
    transform: rotate(45deg);
    content: "";
  }
}
</style>
